<!-- <p-toast [style]="{marginTop: '80px'}"></p-toast> -->
<div style="padding-top: 1em; padding-bottom: 1em;">
  <div class="container d-flex justify-content-between">
    <h4>Velocidad (km/h) / Presión (bar) / Rpm / Dosis / Caudal (l/min)</h4>
    <div class="d-flex gap-2">
      <button pButton type="button" icon="fa fa-angle-double-left" (click)="replaceContent('begin')" [disabled]="countChart() === 0"></button> 
      <button pButton type="button" icon="fa fa-angle-left" (click)="replaceContent('previous')" [disabled]="countChart() === 0"></button>
      <div style="position: relative; top: 10px; margin: 0 10px;">
        {{ countChart() + 1 }} / {{ max_chart_pages() }}
      </div>
      <button pButton type="button" icon="fa fa-angle-right" (click)="replaceContent('next')" [disabled]="elments_per_page * (countChart() + 2) >= grafica_vel().labels.length"></button>
      <button pButton type="button" icon="fa fa-angle-double-right" (click)="replaceContent('final')" [disabled]="elments_per_page * (countChart() + 2) >= grafica_vel().labels.length"></button>
    </div>
  </div>
  <p class="w-100 text-center">Clicar en los botones para navegar entre las gráficas</p>
  <p-chart type="line" [data]="data()" (onDataSelect)="selectData()" height="500" [options]="options"></p-chart>
</div>